import { render, staticRenderFns } from "./OnboardingForm.vue?vue&type=template&id=e2659e34&"
import script from "./OnboardingForm.vue?vue&type=script&lang=ts&"
export * from "./OnboardingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports